import { PhonemeInfo } from "../pattern/phonemeInfo";
import { IpaType, syllableBreak } from "../phonemes/ipa";
import { segmentPhonemes } from "../phonemes/segmentPhonemes";
import { findSyllables } from "../phonotactics/findSyllables";
import { SyllablePhonotactics } from "../phonotactics/phonotactics";
import { SegmentStrategy } from "./intoSegments";

/** IPA -> syllables -> IPA w/ syllable separators */
export function addSyllableBreaks(
  ipa: IpaType, pt: SyllablePhonotactics<PhonemeInfo> | IpaType[], strategy?: SegmentStrategy
): string {
  const type = strategy === SegmentStrategy.SynthSymbols ? 'synth'
    : strategy === SegmentStrategy.Single ? 'ipa'
      : strategy === SegmentStrategy.PreferIpaPlus ? 'ipaPlus' : strategy;
  const segments = segmentPhonemes(ipa, type, Array.isArray(pt) ? 'all-aff' : pt.affricates);
  const input = segments.phonemes.filter(p => !p.meta || p.meta === 'stress').map(p => p.phoneme);
  const syllables = findSyllables(input, pt);
  if (!syllables) {
    return ipa; // couldn't add breaks, so just use word as-is
  }

  let phonemes: string[] = [];
  let current = 0;
  for (const n of syllables) {
    if (current !== 0) {
      phonemes.push(syllableBreak);
    }
    for (let i = current; i < current + n; i++) {
      phonemes.push(input[i]);
    }
    current += n;
  }
  return phonemes.join('');
}
